/**
* 门店订单模块接口（意向单、推送单）
*/
import axios from '@/request/http';
import rawAxios from 'axios';

const storeOrder = {
    //获取采购意向单列表
    getIntentionList(params) {
        return axios.get('/order/purchaseIntention/getIntentionList', { params });
    },
    //获取采购意向单详情
    getIntentionDetail(params) {
        return axios.get('/order/purchaseIntention/getIntentionDetail', { params });
    },
    //新增采购意向单（后端要求application/json，使用原生axios绕过拦截器的qs.stringify）
    addIntention(params) {
        return rawAxios.post('/order/purchaseIntention/addIntention', params, {
            headers: { 'Content-Type': 'application/json' }
        });
    },
    //获取门店推送单列表
    getStorePushOrderList(params) {
        return axios.get('/order/storePushOrder/getStorePushOrderList', { params });
    },
    //获取门店推送单详情
    getStorePushOrderDetail(params) {
        return axios.get('/order/storePushOrder/getStorePushOrderDetail', { params });
    },
}

export default storeOrder;



// WEBPACK FOOTER //
// ./src/request/api/order/storeOrder.js